import { useIsLoggedOutDiscoverPage } from "@faire/retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { useLocation } from "react-router-dom";

import { isComingFromSocial } from "./navigation-origin/isComingFromSocial";
import { useIsSemDiscoverPage } from "./useIsSemDiscoverPage";

/**
 * @name useIsLoggedOutOrganicDiscoverPage
 * @description Determines if user is a non-paid user
 * and if the current page is the logged out discover page.
 */
export const useIsLoggedOutOrganicDiscoverPage = (): boolean => {
  const isLoggedOutSEMDiscoverPage = useIsSemDiscoverPage();
  const isLoggedOutDiscoverPage = useIsLoggedOutDiscoverPage();
  const location = useLocation();
  const isSocial = isComingFromSocial(location);

  return isLoggedOutDiscoverPage && !isLoggedOutSEMDiscoverPage && !isSocial;
};
